import React from 'react'
import PropTypes from 'prop-types'
import trans from 'counterpart'
import 'leaflet/dist/leaflet.css'
import { RESORT_RESORT, RESORT_HOLIDAYPARK } from '../../modules/reservation/constants'
import { APP_DIERENBOS } from '../../constants/apps'
// import FullscreenControl from './FullscreenControl'

class ResortMap extends React.Component {
  state = {
    clientSide: false
  }

  componentDidMount = () => {
    // We're manually requiring the (react-)leaflet dependencies here, since leaflet
    // does not support serverside rendering.
    if (typeof window !== 'undefined') {
      const { Map, ImageOverlay } = require('react-leaflet')
      const { LatLngBounds, LatLng, CRS } = require('leaflet')
      const { default: FullscreenControl } = require('./FullscreenControl')

      this.setState({
        Map,
        ImageOverlay,
        FullscreenControl,
        LatLngBounds,
        LatLng,
        CRS,
        clientSide: true
      })
    }
  }

  getMapData = () => {
    const locale = trans('locale')
    const { LatLngBounds, LatLng } = this.state
    const { resort } = this.props

    if (process.env.RAZZLE_APP === APP_DIERENBOS) {
      return {
        url: `https://${process.env.RAZZLE_MEDIA_HOST}/map/dierenbos-${locale}.png`,
        width: 100,
        height: 70.71,
        bounds: new LatLngBounds(new LatLng(70.71, 0), new LatLng(0, 100))
      }
    }

    switch (resort) {
      case RESORT_RESORT: {
        return {
          url: `https://${process.env.RAZZLE_MEDIA_HOST}/map/resort-${locale}.png`,
          width: 100,
          height: 70.71,
          bounds: new LatLngBounds(new LatLng(70.71, 0), new LatLng(0, 100))
        }
      }
      case RESORT_HOLIDAYPARK: {
        return {
          url: `https://${process.env.RAZZLE_MEDIA_HOST}/map/holidaypark-${locale}.png`,
          width: 100,
          height: 70.71,
          bounds: new LatLngBounds(new LatLng(70.71, 0), new LatLng(0, 100))
        }
      }
    }

    throw new Error('No maps are configured for this resort')
  }

  render = () => {
    if (this.state.clientSide !== true) {
      return null
    }

    const { Map, ImageOverlay, CRS, FullscreenControl } = this.state

    const mapData = this.getMapData()

    return (
      <Map
        attributionControl={false}
        center={[mapData.height / 2, mapData.width / 2]}
        crs={CRS.Simple}
        maxBounds={mapData.bounds}
        zoom={3}
        minZoom={3}
        style={{ height: '100%' }}
      >
        <ImageOverlay
          url={mapData.url}
          bounds={mapData.bounds}
        />
        <FullscreenControl />
      </Map>
    )
  }
}

ResortMap.propTypes = {
  resort: PropTypes.string.isRequired
}

export default ResortMap
